import React, { useState } from "react";
import PageWrapper from "./components/PageWrapper";
import { useFormCtx } from "./FormContext";
import Button from "./components/Button";
import TransitionBlock from "./components/TransitionBlock";
import * as Const from "./_Const";
import useScreenType from "./hooks/useScreenType";
import useTimeout from "./hooks/useTimeout";

const PAGE_ID_TOP_NESTED = 6;
const PAGE_ID_DOCTORS = 4;
const PAGE_ID_BUTTONS = 1;

function PageButtons() {
  const screenType = useScreenType();
  const [number, setNumber] = useState(1);
  // const { clear: clearTimer, reset: resetTimer } = useTimeout(() => navigateAfterTimeout(), Const.PAGE_EXPIRED_TIME);
  const { currentBtnPageIndex, navigateNextButtons, selectedButtonId, getApiPage, getButtonsData } = useFormCtx();
  const isTerminal = Const.isTerminal();
  const index = isTerminal ? Const.REG_RPI_REASON_BUTTON_INDEX : Const.REG_01_INDEX;

  //const page = getPageData(index);

  const buttonsData = getButtonsData();
  const noNestingData = getButtonsFilter(PAGE_ID_BUTTONS);
  const firstNestingData = getButtonsFilter(PAGE_ID_DOCTORS);
  const secondNestingData = getButtonsFilter(PAGE_ID_TOP_NESTED);

  // function navigateAfterTimeout() {
  //   //zde si handluje timeout jen terminal, jinak se to resi ve formcontext,
  //   // ale protoze timout potrebuji v ramci terminalu jen zde a v ostanich page jako PageCameraTest
  //   //  atd to nepotrbuji je jednodussi mit jen 1 timeout zde nez delat vyjimky na vse ostatni
  //   if (isTerminal) {
  //   }
  // }

  function getButtonsFilter(page) {
    return buttonsData ? buttonsData.filter((item) => item.pageId === page) : null;
  }

  function getButtonsFind(data, id) {
    return data ? data.find((item) => item.doctorId === id) : null;
  }

  function getData() {
    let data = null;
    if (secondNestingData && secondNestingData.length > 0) {
      log("6 exists");
      if (currentBtnPageIndex == 0) {
        data = secondNestingData;
      } else if (currentBtnPageIndex == 1) {
        data = getButtonsFind(firstNestingData, selectedButtonId);
      } else if (currentBtnPageIndex == 2) {
        data = getButtonsFind(noNestingData, selectedButtonId);
      }
    } else {
      log("6 not exists");
      if (firstNestingData && firstNestingData.length > 0) {
        log("4 exists");
        if (currentBtnPageIndex == 0) {
          data = firstNestingData;
        } else if (currentBtnPageIndex == 1) {
          data = getButtonsFind(noNestingData, selectedButtonId);
        }
      } else {
        log("4 not exists");
        if (noNestingData && noNestingData.length > 0) {
          log("1 exists");
          if (currentBtnPageIndex == 0) {
            data = noNestingData;
          }
        } else {
          log("1 not exists");
        }
      }
    }

    if (data && data.length === 1) {
      data = data[0];
    }
    //console.log(data);
    return data;
  }

  function log(text) {
    // console.log(text);
  }

  function getTestData() {
    const source = {
      title: "Důvod návštěvy",
      subtitle: "Zvolte důvod návštěvy",
      buttons: [
        {
          id: 1,
          order: 1,
          queueId: 1005,
          text: "Vyšetření",
          /*text: "Administrativan\nVýpis z dok.\nLístek na peníze",*/
        },
        {
          id: 2,
          order: 2,
          queueId: 1044,
          text: "Recept",
        },
        {
          id: 3,
          order: 3,
          queueId: 1043,
          text: "Kontrola",
        },
        {
          id: 4,
          order: 4,
          queueId: 1045,
          text: "Administrativa",
        },
        {
          id: 5,
          order: 5,
          queueId: 1046,
          text: "Ostatní",
        },
        {
          id: 6,
          order: 6,
          queueId: 1047,
          text: "Produktivita",
        },
        {
          id: 7,
          order: 7,
          queueId: 1048,
          text: "Injekce",
        },
        {
          id: 8,
          order: 8,
          queueId: 1049,
          text: "Lístek na peníze",
        },

        {
          id: 9,
          order: 9,
          queueId: 1050,
          text: "Jsem objednán(a)",
        },
        {
          id: 10,
          order: 10,
          queueId: 1051,
          text: "Recepty, Kontrola krev. tlaku",
        },
      ],
    };

    console.log(number);

    const filtered = source.buttons.filter((i, index) => index < number);

    return { ...source, buttons: filtered };
  }

  //pro testovani zadat getTestData()
  let data = getData(); //getTestData(); //getData();
  //console.log(data);

  const showTitleOnNavbar = isTerminal;
  let showSubtitle = data?.buttons?.length >= 8 ? false : true;
  if (isTerminal) {
    showSubtitle = false; // v terminalu bude subtitle v ramci navbar a ne jako h1 stranky
  } else {
  }

  //const text = "Přednostní vyšetření text a";
  function canWrapTitle(title) {
    let canWrap = false;

    const len = title?.length ?? 0;
    // console.log(len);

    if (len > 25) {
      canWrap = true;
    }
    // console.log(title, len, canWrap);
    return canWrap;
  }

  //pro testovani vice tlacitek
  function handleTestButtonsClick(params) {
    if (number === 10) {
      setNumber(1);
    } else {
      setNumber(number + 1);
    }
  }

  function getFormatClass() {
    const count = data?.buttons?.length ?? 0;
    // console.log(count);

    let className = "flex flex-col space-y-4";
    let marginCss = "";
    let framerCss = "";
    let buttonCss;
    let showInfo = true;
    if (Const.isTerminal()) {
      switch (count) {
        case 2:
          if (screenType === Const.SCREEN_RPIV1) {
            marginCss = "mt-5";
            buttonCss = "h-[160px] text-4xl";
          } else if (screenType === Const.SCREEN_RPIV2) {
            marginCss = "mt-8";
            buttonCss = "h-[255px] text-6xl";
          } else {
            marginCss = "mt-8";
            buttonCss = "h-[295px] text-6xl";
          }
          break;
        case 3:
          if (screenType === Const.SCREEN_RPIV1) {
            marginCss = "mt-5";
            buttonCss = "h-[101px] text-4xl";
          } else if (screenType === Const.SCREEN_RPIV2) {
            marginCss = "mt-8";
            buttonCss = "h-[165px] text-5xl";
          } else {
            marginCss = "mt-8";
            buttonCss = "h-[24vh] text-5xl";
          }
          break;
        case 4:
          if (screenType === Const.SCREEN_RPIV1) {
            marginCss = "mt-5";
            buttonCss = "h-[72px] text-2xl";
          } else if (screenType === Const.SCREEN_RPIV2) {
            marginCss = "mt-8";
            buttonCss = "h-[120px] text-4xl";
          } else {
            marginCss = "mt-8";
            buttonCss = "h-[140px] text-4xl";
          }
          break;
        case 5:
          framerCss = "first:col-span-2";
          className = "grid grid-cols-2 gap-4 self-center items-center";

          if (screenType === Const.SCREEN_RPIV1) {
            marginCss = "mt-5";
            buttonCss = "h-[101px] text-2xl";
          } else if (screenType === Const.SCREEN_RPIV2) {
            marginCss = "mt-8";
            buttonCss = "h-[165px] text-4xl";
          } else {
            marginCss = "mt-8";
            buttonCss = "h-[24vh] text-4xl";
          }

          break;
        case 6:
          className = "grid grid-cols-2 gap-4 self-center items-center";

          if (screenType === Const.SCREEN_RPIV1) {
            marginCss = "mt-5";
            buttonCss = "h-[101px] text-2xl";
          } else if (screenType === Const.SCREEN_RPIV2) {
            marginCss = "mt-8";
            buttonCss = "h-[165px] text-4xl";
          } else {
            marginCss = "mt-8";
            buttonCss = "h-[24vh] text-4xl";
          }
          break;
        case 7:
          framerCss = "first:col-span-2";

          if (screenType === Const.SCREEN_RPIV1) {
            marginCss = "mt-5";
            buttonCss = "h-[75px] text-2xl";
            className = "grid grid-cols-2 gap-3 self-center items-center";
          } else if (screenType === Const.SCREEN_RPIV2) {
            marginCss = "mt-8";
            buttonCss = "h-[120px] text-4xl";
            className = "grid grid-cols-2 gap-4 self-center items-center";
          } else {
            marginCss = "mt-8";
            buttonCss = "h-[140px] text-4xl";
            className = "grid grid-cols-2 gap-4 self-center items-center";
          }
          break;
        case 8:
          if (screenType === Const.SCREEN_RPIV1) {
            marginCss = "mt-5";
            buttonCss = "h-[75px] text-2xl";
            className = "grid grid-cols-2 gap-3 self-center items-center";
          } else if (screenType === Const.SCREEN_RPIV2) {
            marginCss = "mt-8";
            buttonCss = "h-[120px] text-3xl";
            className = "grid grid-cols-2 gap-4 self-center items-center";
          } else {
            marginCss = "mt-8";
            buttonCss = "h-[140px] text-3xl";
            className = "grid grid-cols-2 gap-4 self-center items-center";
          }
          break;
        case 9:
          framerCss = "first:col-span-2";

          if (screenType === Const.SCREEN_RPIV1) {
            marginCss = "mt-[18px]";
            buttonCss = "h-[65px] text-xl";
            className = "grid grid-cols-2 gap-3 self-center items-center";
          } else if (screenType === Const.SCREEN_RPIV2) {
            marginCss = "mt-7";
            buttonCss = "h-[100px] text-3xl";
            className = "grid grid-cols-2 gap-4 self-center items-center";
          } else {
            marginCss = "mt-8";
            buttonCss = "h-[116px] text-3xl";
            className = "grid grid-cols-2 gap-4 self-center items-center";
          }
          showInfo = false;
          break;
        case 10:
          if (screenType === Const.SCREEN_RPIV1) {
            marginCss = "mt-[18px]";
            buttonCss = "h-[65px] text-xl";
            className = "grid grid-cols-2 gap-3 self-center items-center";
          } else if (screenType === Const.SCREEN_RPIV2) {
            marginCss = "mt-7";
            buttonCss = "h-[100px] text-3xl";
            className = "grid grid-cols-2 gap-4 self-center items-center";
          } else {
            marginCss = "mt-8";
            buttonCss = "h-[116px] text-3xl";
            className = "grid grid-cols-2 gap-4 self-center items-center";
          }
          showInfo = false;
          break;
      }
    } else {
      //na terminalu nepoustet PING jen na mobilu - je to hodne vytezujici procesor 20-30% i teplotu
      buttonCss = "ping";
    }
    return { css: className, buttonCss, framerCss, showInfo, marginCss };
  }
  const { css, buttonCss, framerCss, showInfo, marginCss } = getFormatClass();

  function getCssFor(what) {
    let css = "";
    if (screenType === Const.SCREEN_RPIV1) {
      switch (what) {
        case "parent-div":
          css = "mt-2 mx-0";
          break;
        case "title":
          css = "text-sm mt-4 mx-0";
          break;
      }
    } else if (screenType === Const.SCREEN_RPIV2) {
      switch (what) {
        case "parent-div":
          css = "mt-4 mx-6";
          break;
        case "title":
          css = "text-lg mt-3 mx-6";
          break;
      }
    } else if (screenType === Const.SCREEN_WAVESHARE) {
      switch (what) {
        case "parent-div":
          css = "mt-4 mx-6";
          break;
        case "title":
          css = "text-lg mt-3 mx-6";
          break;
      }
    } else if (screenType === Const.SCREEN_PHONE) {
      switch (what) {
        case "parent-div":
          css = "mt-4 mx-6";
          break;
        case "title":
          css = "text-sm mt-4 mx-6 ";
          break;
      }
    }
    //console.log(what, screenType, css);

    return css;
  }

  const delay = isTerminal ? 0 : 0.01;

  if (screenType === Const.SCREEN_UNKNOWN) {
    return;
  }

  //console.log("xx", data.title, data.subtitle);

  return (
    <>
      {data && (
        <PageWrapper title={data.title} subtitle={data.subtitle} index={index} showTitleOnNavbar={showTitleOnNavbar}>
          {showSubtitle && <h2 className="mt-6 text-xl font-light text-primary">{data.subtitle}</h2>}
          <div className={`${getCssFor("parent-div")}  ${css} ${marginCss}`}>
            {data &&
              data.buttons &&
              data.buttons.map((item, aIndex) => (
                <TransitionBlock key={item.id} delay={delay * aIndex} className={`${framerCss}`}>
                  <Button
                    className={`w-full ${buttonCss}`}
                    key={item.id}
                    title={item.text}
                    canWrap={canWrapTitle(item.text)}
                    showIcon={item.queueId == 0}
                    // onClick={handleTestButtonsClick}
                    onClick={() => navigateNextButtons(item, index)}
                  />
                </TransitionBlock>
              ))}
          </div>

          {showInfo && <p className={`${getCssFor("title")} text-secondary font-light`}>Kliknutím na jedno z tlačítek přejdete na další obrazovku</p>}
        </PageWrapper>
      )}
    </>
  );
}

export default PageButtons;
